export const enum DeskingTestIds {
  PanelFormActions = 'PanelFormActions',
  SendVia = 'SendVia',
}
